module.exports = __webpack_public_path__ + "img/Rectangle 8.f17f021c.png";